<div class="chat-shell">
  <div class="chat-grid">
    <aside class="sidebar-column">
      <section class="sidebar-panel">
        <div class="panel-header">
          <div class="search-box">
            <i class="bi bi-search search-icon"></i>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="searchQuery"
              (keydown.enter)="searchUsers()"
              placeholder="ค้นหาด้วยรหัสอ้างอิง หรือชื่อ-สกุล, username"
            />
          </div>
        </div>
        <div class="allow-chat-panel">
          <div class="allow-chat-info">
            <span class="allow-chat-label">ค้นหาผู้ติดต่อแชท</span>
            <span class="allow-chat-status" [class.on]="allowChatEnabled">
            {{ allowChatEnabled ? 'เปิดอยู่' : 'ปิดอยู่' }}
          </span>
          </div>
          <button
            type="button"
            class="allow-chat-toggle"
            [class.is-enabled]="allowChatEnabled"
            (click)="toggleAllowChat()"
            [disabled]="updatingAllowChat || !currentUser"
          >
            @if (updatingAllowChat) {
              <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            } @else {
              <i class="bi" [ngClass]="allowChatEnabled ? 'bi-toggle-on' : 'bi-toggle-off'"></i>
            }
            {{ allowChatEnabled ? 'ปิด' : 'เปิด' }}
          </button>
        </div>
        <div class="allow-chat-panel">
          <div class="allow-chat-info">
            <span class="allow-chat-label">ค้นหาด้วย ชือ-สกุล, username</span>
            <span class="allow-chat-status" [class.on]="allowSearchEnabled">
            {{ allowSearchEnabled ? 'เปิดอยู่' : 'ปิดอยู่' }}
          </span>
          </div>
          <button
            type="button"
            class="allow-chat-toggle"
            [class.is-enabled]="allowSearchEnabled"
            (click)="toggleAllowSearch()"
            [disabled]="updatingAllowSearch || !currentUser"
          >
            @if (updatingAllowSearch) {
              <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            } @else {
              <i class="bi" [ngClass]="allowSearchEnabled ? 'bi-toggle-on' : 'bi-toggle-off'"></i>
            }
            {{ allowSearchEnabled ? 'ปิด' : 'เปิด' }}
          </button>
        </div>
        <div class="sidebar-tabs">
          <span class="sidebar-tab active">
            <i class="bi bi-person"></i>
            <span>ข้อความ</span>
            @if (unreadCount > 0) {
              <span class="tab-badge">{{ unreadCount }}</span>
            }
          </span>
          <span class="sidebar-tab">
            <i class="bi bi-tag"></i>
            <span>ผู้ติดต่อ</span>
            <span class="tab-count">{{ contacts.length }}</span>
          </span>
        </div>

        @if (searchResults.length > 0) {
          <div class="search-results">
            <div class="section-label">ผลการค้นหา</div>
            @for (user of searchResults; track trackById($index, user)) {
              <button
                type="button"
                class="result-item"
                (click)="addContact(user)"
              >
                <div class="avatar">
                  @if (user.avatarUrl) {
                    <img [src]="user.avatarUrl" [alt]="user.displayName"/>
                  } @else {
                    <div class="avatar-placeholder"><i class="bi bi-person"></i></div>
                  }
                </div>
                <div class="result-meta">
                  <strong>{{ userLabel(user) }}</strong>
                  <span>{{ user.email || 'ไม่มีอีเมล' }}</span>
                </div>
                <i class="bi bi-plus-circle-fill text-primary fs-5"></i>
              </button>
            }
          </div>
        }

        <div class="sidebar-section-header">ข้อความ</div>
        <div class="contact-list-shell" [class.collapsed]="!contactsExpanded">
          <div class="contact-list" [class.collapsed]="!contactsExpanded">
            @if (loadingContacts) {
              <div class="empty-state">กำลังโหลดรายชื่อ...</div>
            }
            @if (!loadingContacts && contacts.length === 0) {
              <div class="empty-state">ยังไม่มีผู้ติดต่อ</div>
            }

            @for (contact of contacts; track trackByContactId($index, contact)) {
              <button
                type="button"
                class="contact-item"
                [class.active]="selectedContact?.contactId === contact.contactId"
                [class.has-unread]="contact.unreadCount > 0"
                (click)="selectContact(contact)"
              >
                <span class="unread-indicator" [class.visible]="contact.unreadCount > 0"></span>
                <div class="avatar">
                  @if (contact.avatarUrl) {
                    <img [src]="contact.avatarUrl" [alt]="contact.displayName"/>
                  } @else {
                    <div class="avatar-placeholder"><i class="bi bi-person"></i></div>
                  }
                  <span class="presence-dot" [ngClass]="contactPresenceClass(contact)"
                        [attr.aria-label]="isContactOnline(contact) ? 'ออนไลน์' : 'ออฟไลน์'"></span>
                </div>
                <div class="contact-meta">
                  <div class="contact-topline">
                    <strong>{{ contactLabel(contact) }}</strong>
                    <span class="time">{{ formatTime(contact.lastMessageAt) }}</span>
                  </div>
                  <p class="preview mb-0">{{ contact.lastMessage || 'ยังไม่มีข้อความ' }}</p>
                </div>
                @if (contact.unreadCount > 0) {
                  <span class="contact-unread-badge">{{ contact.unreadCount }}</span>
                }
              </button>
            }
          </div>
        </div>
      </section>
    </aside>

    <section class="conversation-panel" [class.has-contact]="!!selectedContact">
      <div class="mobile-contact-shell">
        <section class="mobile-search-panel" [class.collapsed]="!searchExpanded">
          <div class="mobile-search-head">
            <div class="d-flex align-items-center gap-2">
              <button
                type="button"
                class="btn btn-link btn-sm p-0 contact-collapse-toggle"
                (click)="toggleSearchExpanded()"
                [attr.aria-expanded]="searchExpanded"
              >
                <i class="bi" [ngClass]="searchExpanded ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
              </button>
              <div>
                <div class="section-label mb-0">ค้นหา / ผู้ติดต่อ</div>
              </div>
            </div>
          </div>

          <div class="mobile-search-body">
            <div class="search-box mobile-search-box">
              <input
                type="text"
                class="form-control"
                [(ngModel)]="searchQuery"
                (keydown.enter)="searchUsers()"
                placeholder="พิมพ์ชื่อ หรืออีเมล"
              />
            </div>

            @if (searchResults.length > 0) {
              <div class="search-results mobile-search-results">
                <div class="section-label">ผลการค้นหา</div>
                @for (user of searchResults; track trackById($index, user)) {
                  <button
                    type="button"
                    class="result-item"
                    (click)="addContact(user)"
                  >
                    <div class="avatar">
                      @if (user.avatarUrl) {
                        <img [src]="user.avatarUrl" [alt]="user.displayName"/>
                      } @else {
                        <div class="avatar-placeholder"><i class="bi bi-person"></i></div>
                      }
                    </div>
                    <div class="result-meta">
                      <strong>{{ userLabel(user) }}</strong>
                      <span>{{ user.email || 'ไม่มีอีเมล' }}</span>
                    </div>
                    <i class="bi bi-plus-circle"></i>
                  </button>
                }
              </div>
            }
          </div>
        </section>

        <div class="mobile-contact-header">
          <strong>รายชื่อผู้ติดต่อ</strong>
          <button class="btn btn-link btn-sm p-0" (click)="refreshContacts(true)">รีเฟรช</button>
        </div>

        <div class="mobile-contact-strip" [class.collapsed]="!contactsExpanded">
          @for (contact of contacts; track trackByContactId($index, contact)) {
            <button
              type="button"
              class="mobile-contact-item"
              [class.active]="selectedContact?.contactId === contact.contactId"
              (click)="selectContact(contact)"
            >
              <div class="avatar mobile">
                @if (contact.avatarUrl) {
                  <img [src]="contact.avatarUrl" [alt]="contact.displayName"/>
                } @else {
                  <div class="avatar-placeholder"><i class="bi bi-person"></i></div>
                }
                <span class="presence-dot" [ngClass]="contactPresenceClass(contact)"></span>
              </div>
              <span class="mobile-contact-name">{{ contactLabel(contact) }}</span>
              @if (contact.unreadCount > 0) {
                <span class="mobile-contact-badge">{{ contact.unreadCount }}</span>
              }
            </button>
          }
        </div>
      </div>

      @if (selectedContact) {
        <div class="conversation-header">
          <div class="d-flex align-items-center gap-3">
            <button type="button" class="btn btn-link btn-sm p-0 mobile-back-btn" (click)="backToContactList()"
                    aria-label="กลับ">
              <i class="bi bi-arrow-left"></i>
            </button>
            <div class="avatar large">
              @if (selectedContact.avatarUrl) {
                <img [src]="selectedContact.avatarUrl" [alt]="selectedContact.displayName"/>
              } @else {
                <div class="avatar-placeholder"><i class="bi bi-person"></i></div>
              }
              <span class="presence-dot" [ngClass]="contactPresenceClass(selectedContact)"></span>
            </div>
            <div>
              <h2>{{ contactLabel(selectedContact) }}</h2>
              <p class="mb-0">{{ selectedContact.email || 'ไม่มีอีเมล' }}</p>
            </div>
          </div>
        </div>

        <div #messagePanel class="message-panel" (scroll)="onMessagePanelScroll()">
          @if (loadingMessages) {
            <div class="empty-state">กำลังโหลดข้อความ...</div>
          }
          @if (!loadingMessages && messages.length === 0) {
            <div class="empty-state">เริ่มคุยข้อความแรกได้เลย</div>
          }

          @for (message of messages; track trackByMessageId($index, message)) {
            <div class="message-row" [class.mine]="message.mine">
              @if (!message.mine) {
                <div class="message-avatar">
                  <div class="avatar small">
                    @if (selectedContact.avatarUrl) {
                      <img [src]="selectedContact.avatarUrl" [alt]="message.senderName"/>
                    } @else {
                      <div class="avatar-placeholder"><i class="bi bi-person"></i></div>
                    }
                  </div>
                </div>
              }
              <div class="message-content">
                @if (!message.mine) {
                  <div class="message-meta">
                    <span class="sender">{{ message.senderName || 'ผู้ใช้' }}</span>
                    <span class="time">{{ formatTime(message.createdAt) }}</span>
                  </div>
                }
                <div class="message-bubble">
                  @if (message.messageType === 'text') {
                    <div class="message-body">{{ message.messageData }}</div>
                  } @else if (isImageMessage(message)) {
                    <button type="button" class="image-attachment" (click)="openImageModal(message)">
                      <img [src]="message.messageData" [alt]="messageAttachmentName(message.messageData)">
                    </button>
                  } @else {
                    <a class="attachment-chip" [href]="message.messageData" target="_blank" rel="noopener noreferrer">
                      <i class="bi bi-paperclip"></i>
                      <span>{{ messageAttachmentName(message.messageData) }}</span>
                    </a>
                  }
                </div>
                @if (message.mine) {
                  <div class="message-meta mine">
                    <span class="time">{{ formatTime(message.createdAt) }}</span>
                  </div>
                }
              </div>
            </div>
          }
        </div>

        <div class="composer" [class.drag-active]="attachmentDragging"
             (dragover)="onComposerDragOver($event)"
             (dragleave)="onComposerDragLeave($event)"
             (drop)="onComposerDrop($event)">
          <input
            #attachmentInput
            type="file"
            class="d-none"
            multiple
            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            (change)="onAttachmentSelected($event)">

          @if (hasAttachments()) {
            <div class="attachment-preview-list">
              @for (attachment of attachmentFiles; track trackByAttachmentIndex($index); let i = $index) {
                <div class="attachment-preview-item">
                  @if (attachment.type === 'image' && attachment.previewUrl) {
                    <img class="attachment-preview-image" [src]="attachment.previewUrl" [alt]="attachment.name">
                  } @else {
                    <div class="attachment-preview-meta">
                      <i class="bi" [ngClass]="attachmentIconClass()"></i>
                      <div>
                        <strong>{{ attachment.name }}</strong>
                        <span>{{ attachmentKindLabel(attachment) }}</span>
                      </div>
                    </div>
                  }
                  <button type="button" class="btn btn-link p-0" (click)="removeAttachmentAt(i)">ลบ</button>
                </div>
              }
            </div>
          }

          <div class="composer-input-row">
            <button class="btn btn-default bg-white" type="button" (click)="openAttachmentPicker()" [disabled]="sending"
                    aria-label="แนบไฟล์">
              <i class="bi bi-paperclip"></i>
            </button>
            <textarea
              #composerTextarea
              class="form-control"
              rows="1"
              [(ngModel)]="draftMessage"
              (keydown)="onComposerKeydown($event)"
              [placeholder]="hasAttachments() ? '' : 'พิมพ์ข้อความ'"
              [disabled]="sending || hasAttachments()"></textarea>
            <button
              type="button"
              class="btn btn-primary"
              (mousedown)="$event.preventDefault()"
              (click)="sendMessage()"
              [disabled]="sending || (!draftMessage.trim() && !hasAttachments())"
              aria-label="ส่ง"
            >
              <i class="bi bi-send-fill"></i>
            </button>
          </div>
        </div>
      } @else {
        <div class="empty-conversation">
          <div>
            <h2>เลือกผู้ติดต่อ</h2>
            <p class="mb-0">ค้นหาและเพิ่มผู้ติดต่อเพื่อเริ่มสนทนา</p>
          </div>
        </div>
      }
    </section>
  </div>
</div>

@if (imageViewerOpen) {
  <div
    class="chat-image-modal"
    role="dialog"
    aria-modal="true"
    (click)="closeImageModal()"
  >
    <div class="chat-image-modal-dialog" (click)="$event.stopPropagation()">
      <button type="button" class="chat-image-modal-close" (click)="closeImageModal()" aria-label="ปิด">
        <i class="bi bi-x-lg"></i>
      </button>

      <button
        type="button"
        class="chat-image-modal-nav chat-image-modal-nav-prev"
        (click)="showPreviousImage()"
        [disabled]="!hasPreviousImage"
        aria-label="รูปก่อนหน้า"
      >
        <i class="bi bi-chevron-left"></i>
      </button>

      <button
        type="button"
        class="chat-image-modal-nav chat-image-modal-nav-next"
        (click)="showNextImage()"
        [disabled]="!hasNextImage"
        aria-label="รูปถัดไป"
      >
        <i class="bi bi-chevron-right"></i>
      </button>

      @if (imageViewerLoading) {
        <div class="chat-image-modal-loading">
          <div class="spinner-border text-light" role="status" aria-label="กำลังโหลดรูป"></div>
        </div>
      }

      @if (!imageViewerLoading && imageViewerSrc) {
        <img
          [src]="imageViewerSrc"
          [alt]="imageViewerAlt"
          class="chat-image-modal-image"
        />
      }
    </div>
  </div>
}
